import { render, staticRenderFns } from "./desk1.vue?vue&type=template&id=3f004fac&scoped=true&"
import script from "./desk1.vue?vue&type=script&lang=js&"
export * from "./desk1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f004fac",
  null
  
)

export default component.exports